import React from 'react';
import cls from 'classnames';
import { Alert } from 'reactstrap';
import { FormGroupColumn, toasty } from '../common/forms/FormElements';
import CrewMemberStartTimeButton from './CrewMemberStartTimeButton';
import {
    getDisplayedCrewOverrideStartTime,
    getPersistedCrewOverrideStartTime,
    hasPersistedCrewOverrides,
    updateCrewOverrideStartTimes,
} from './CrewDisplayHelpers';

export default class CrewMemberDisplay extends React.Component {
    onCrewLeadChanged = (crewLeadEmployeeId) => {
        const { job, crew, onJobUpdated } = this.props;
        const isSelectedCrewMember = (job?.crewEmployeeMemberships || []).some(
            (employeeId) => employeeId == crewLeadEmployeeId
        );

        if (
            !job ||
            !onJobUpdated ||
            (crewLeadEmployeeId != null && !isSelectedCrewMember) ||
            job.crewLeadEmployeeId == crewLeadEmployeeId
        ) {
            return;
        }

        job.crewLeadEmployeeId = crewLeadEmployeeId;
        job.foremenId = crewLeadEmployeeId;

        if (job.crewName === crew?.name) {
            job.crewName = `${job.crewName}*`;
        }

        onJobUpdated(job);
    };

    onCrewEmployeeChanged = (employeeId) => {
        const { job, onCrewComponentsChanged } = this.props;
        let crewEmployeeMemberships = [...(job?.crewEmployeeMemberships || [])];

        if (crewEmployeeMemberships.includes(employeeId)) {
            crewEmployeeMemberships = crewEmployeeMemberships.filter(
                (cemi) => cemi && cemi != employeeId
            );

            if (job?.crewLeadEmployeeId == employeeId) {
                this.onCrewLeadChanged(null);
                toasty.warning(
                    'Crew Lead Removed',
                    'The crew lead selection has been cleared because this employee was removed.'
                );
            }
        } else {
            crewEmployeeMemberships.push(employeeId);
        }

        onCrewComponentsChanged(crewEmployeeMemberships, null);
    };

    updateOverrideStartTimes = (overrideKey, idKey, resourceId, value) =>
        updateCrewOverrideStartTimes(
            this.props.job,
            this.props.onCrewComponentsChanged,
            overrideKey,
            idKey,
            resourceId,
            value
        );

    render() {
        const {
            crew,
            employees,
            job,
            disabled,
            hasSelectedCrewWithoutLead,
            onCrewComponentsChanged,
            jobResourceOverrides,
        } = this.props;

        if (!crew) {
            return null;
        }

        const crewMembers = (employees || []).filter((employee) =>
            crew.crewEmployeeMemberships.includes(employee.id)
        );
        const crewEmployeeMemberships = job?.crewEmployeeMemberships || [];
        const crewLeadEmployeeId =
            job?.crewLeadEmployeeId !== undefined
                ? job.crewLeadEmployeeId
                : crew.crewLeadEmployeeId;
        const editMode = Boolean(
            onCrewComponentsChanged &&
            job?.crewEmployeeMemberships &&
            job?.crewEquipmentMemberships &&
            !disabled
        );
        const showEmployeeStartTimes =
            editMode ||
            hasPersistedCrewOverrides(jobResourceOverrides, 'employeeId');

        return (
            <FormGroupColumn>
                <label className="control-label">Employees</label>
                <table className="table table-striped table-sm">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Group</th>
                            {showEmployeeStartTimes && <th>Start Time</th>}
                            {editMode && <th>Selected</th>}
                            <th>Crew Lead</th>
                        </tr>
                    </thead>
                    <tbody>
                        {crewMembers.map((crewMember) => (
                            <tr
                                key={`crewMemberTr${crewMember.id}`}
                                onClick={() => {
                                    if (editMode) {
                                        this.onCrewEmployeeChanged(
                                            crewMember.id
                                        );
                                    }
                                }}
                                className={cls('crew-display-employee', {
                                    'deselected-component':
                                        editMode &&
                                        !job.crewEmployeeMemberships.includes(
                                            crewMember.id
                                        ),
                                    'disabled-component': disabled,
                                    'crew-lead':
                                        (crewEmployeeMemberships || []).some(
                                            (employeeId) =>
                                                employeeId == crewMember.id
                                        ) &&
                                        crewLeadEmployeeId == crewMember.id,
                                })}
                            >
                                <td>
                                    {crewMember.lastName},{' '}
                                    {crewMember.firstName}
                                </td>
                                <td>
                                    {crewMember.groups
                                        .map((cmg) => cmg.groupName)
                                        .join(', ')}
                                </td>
                                {showEmployeeStartTimes && (
                                    <td onClick={(e) => e.stopPropagation()}>
                                        {editMode ? (
                                            <CrewMemberStartTimeButton
                                                value={getDisplayedCrewOverrideStartTime(
                                                    job,
                                                    jobResourceOverrides,
                                                    'employeeOverrideStartTimes',
                                                    'employeeId',
                                                    crewMember.id
                                                )}
                                                onChange={(value) =>
                                                    this.updateOverrideStartTimes(
                                                        'employeeOverrideStartTimes',
                                                        'employeeId',
                                                        crewMember.id,
                                                        value
                                                    )
                                                }
                                                label={`${crewMember.lastName}, ${crewMember.firstName}`}
                                                disabled={disabled}
                                            />
                                        ) : (
                                            getPersistedCrewOverrideStartTime(
                                                jobResourceOverrides,
                                                'employeeId',
                                                crewMember.id
                                            ) || ''
                                        )}
                                    </td>
                                )}
                                {editMode && (
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={crewEmployeeMemberships.includes(
                                                crewMember.id
                                            )}
                                            readOnly={true}
                                        />
                                    </td>
                                )}
                                <td onClick={(e) => e.stopPropagation()}>
                                    <input
                                        type="checkbox"
                                        checked={
                                            crewLeadEmployeeId == crewMember.id
                                        }
                                        disabled={
                                            !editMode ||
                                            !crewEmployeeMemberships.some(
                                                (employeeId) =>
                                                    employeeId == crewMember.id
                                            )
                                        }
                                        onChange={(e) =>
                                            this.onCrewLeadChanged(
                                                e.target.checked
                                                    ? crewMember.id
                                                    : null
                                            )
                                        }
                                    />
                                </td>
                            </tr>
                        ))}

                        {!crewMembers.length && (
                            <tr>
                                <td
                                    colSpan={
                                        3 +
                                        (showEmployeeStartTimes ? 1 : 0) +
                                        (editMode ? 1 : 0)
                                    }
                                >
                                    No employees assigned to crew.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                {hasSelectedCrewWithoutLead && (
                    <Alert fade={false} color="warning">
                        Select a crew lead for the selected crew members before
                        saving.
                    </Alert>
                )}
            </FormGroupColumn>
        );
    }
}
